import styled from 'styled-components';

const StyledSignInWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  background-color: #c4c6cc;
`;

export default StyledSignInWrapper;
